import {ISubscription} from '../../models';
import {PLAN_NAME} from './constants';

export const redirectToExternal = (url: string, open_in_new_tab: boolean) => {
  if (url && open_in_new_tab) {
    window.open(url, '_blank', 'noopener,noreferrer');
  } else if (url) {
    window.location.href = url;
  }
}

export const isNoPlan = (subscription: ISubscription | undefined | null) => {
  return isPlan(subscription, PLAN_NAME.NO_PLAN);
}

export const isFreePlan = (subscription: ISubscription | undefined | null) => {
  return isPlan(subscription, PLAN_NAME.FREE);
}

export const isTeamPlan = (subscription: ISubscription | undefined | null) => {
  return isPlan(subscription, PLAN_NAME.TEAM);
}

export const isBusinessPlan = (subscription: ISubscription | undefined | null) => {
  return isPlan(subscription, PLAN_NAME.BUSINESS);
}

const isPlan = (subscription: ISubscription | undefined | null, planName: string) => {
  if (!subscription) {
    return false;
  }
  return subscription.plan.name.toLowerCase() === planName;
}

export const isTrial = (subscription: ISubscription | undefined | null) => {
  const trialEnd = new Date(subscription?.plan?.trial_end as string);
  const now = new Date();

  return subscription?.status === 'trialing' && !!subscription?.plan?.trial_end &&
    (trialEnd.getTime() > now.getTime());
}

export const isCanceled = (subscription: ISubscription | undefined | null) => {
  return subscription?.status === 'canceled' || !!subscription?.canceled_on;
}

export const trialExpiresInDays = (subscription: ISubscription | undefined | null): number => {
  if (isTrial(subscription)) {
    return noOfDaysUntil(subscription?.plan?.trial_end as string);
  }
  return 0;
}

export const noOfDaysUntil = (dateStr: string): number => {
  const dateObj = new Date(dateStr as string);
  const now = new Date();

  if (dateObj.getTime() > now.getTime()) {
    /*
     * trial period expires in the future
     */
    const oneDay = 3600 * 24 * 1000;
    return Math.round((dateObj.getTime() - now.getTime()) / oneDay);
  }
  return 0;
};

export const isPaid = (subscription: ISubscription | undefined | null) => {
  return !isTrial(subscription) && !!subscription?.subscription_id && subscription.status === 'active' &&
    !isCanceled(subscription);
}
